import { Component, OnInit, signal } from '@angular/core';
import { CmUiChipTone } from '@cm/ui-modules';
import { SHARED_IMPORTS } from '@shared/shared-providers';

export const AUDIT_REPORT_SESSION_KEY = 'audit_report_data';

export interface AuditReportCreatedBy {
  id?: number;
  uuid?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  businessTitle?: string;
}

export interface AuditReportTask {
  token?: string;
  status?: string;
  lastUpdated?: string;
  campaignTitle?: string;
  campaignName?: string;
  receiverFirstname?: string;
  receiverLastname?: string;
  receiverEmail?: string;
  receiverPhone?: string;
  receiverExternalId?: string;
  senderFirstname?: string;
  senderLastname?: string;
  senderEmail?: string;
  senderPhone?: string;
  senderExternalId?: string;
}

export interface AuditReportAsset {
  uuid?: string;
  name?: string;
  filename?: string;
  assetUrl?: string;
  lastUpdated?: string;
  createdBy?: AuditReportCreatedBy;
  txt?: string;
  vtt?: string;
  tasks?: AuditReportTask[];
}

export interface AuditReportData {
  assets: AuditReportAsset[];
  generatedAt: string;
}

@Component({
  selector: 'app-audit-report-page',
  templateUrl: './audit-report-page.component.html',
  styleUrls: ['./audit-report-page.component.scss'],
  standalone: true,
  imports: [SHARED_IMPORTS],
})
export class AuditReportPageComponent implements OnInit {
  reportData = signal<AuditReportData | null>(null);

  get baseUrl(): string {
    return window.location.origin;
  }

  thumbnailUrl(filename: string): string {
    return `${this.baseUrl}/mediaassets/${filename}.gif`;
  }

  previewUrl(token: string): string {
    return `${this.baseUrl}/n/${token}-p`;
  }

  creatorInitials(createdBy: AuditReportCreatedBy): string {
    return (createdBy.firstName?.[0] ?? '') + (createdBy.lastName?.[0] ?? '');
  }

  toDate(timestamp: string | undefined): Date | null {
    if (!timestamp) return null;
    const n = Number(timestamp);
    return isNaN(n) ? new Date(timestamp) : new Date(n * 1000);
  }

  statusTone(status: string | undefined): CmUiChipTone {
    switch (status?.toLowerCase()) {
      case 'sent':     return 'success';
      case 'viewed':
      case 'opened':   return 'info';
      case 'pending':  return 'warning';
      case 'rejected': return 'danger';
      default:         return 'neutral';
    }
  }

  ngOnInit(): void {
    const raw = sessionStorage.getItem(AUDIT_REPORT_SESSION_KEY);
    if (raw) {
      this.reportData.set(JSON.parse(raw));
      sessionStorage.removeItem(AUDIT_REPORT_SESSION_KEY);
    }
  }

  print(): void {
    window.print();
  }
}
